import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const CatalogHealthViewPage = lazy(
  () => import("../../workspace/mv/catalog-health-view/Page")
);

const FulfillmentOrderFlipPrototypePage = lazy(
  () => import("../../pages/FulfillmentOrderFlipPrototype")
);

const FulfillmentProductAddOnsPage = lazy(
  () => import("../../pages/FulfillmentProductAddOns")
);

const FaireSourceMinimumIndicatorsPage = lazy(
  () => import("../../workspace/mv/fs-minimum-indicators/Page")
);

const FaireSourceShopHaulPage = lazy(
  () => import("../../workspace/mv/fs-shop-haul/Page")
);

export function MaxVanostrilloRoutes() {
  return (
    <Switch>
      <Route path="/mv/catalog-health-view" component={CatalogHealthViewPage} />
      <Route
        path="/mv/fbf-fbb-order-flip"
        component={FulfillmentOrderFlipPrototypePage}
      />
      <Route
        path="/mv/fulfillment-product-add-ons"
        component={FulfillmentProductAddOnsPage}
      />
      <Route
        path="/mv/fs-minimum-indicators"
        component={FaireSourceMinimumIndicatorsPage}
      />
      <Route path="/mv/fs-shop-haul" component={FaireSourceShopHaulPage} />
    </Switch>
  );
}

export const slug = "mv";
